import PouchDB from 'pouchdb';
var PouchDbHelpers = /** @class */ (function () {
    //Class constructor
    function PouchDbHelpers() {
        //Store database
        this.db = null;
        //Database name
        this.dbName = 'eosPlDb';
        this._Init();
    }
    //Class initializer
    PouchDbHelpers.prototype._Init = function () {
        this.db = new PouchDB(this.dbName, {
            auto_compaction: true
        });
    };
    ;
    //Get pouch db document
    PouchDbHelpers.prototype.Get = function (docName) {
        var that = this;
        return new Promise(function (resolve, reject) {
            that.db.get(docName, {}, function (err, doc) {
                if (err) {
                    reject("Document not found");
                }
                else {
                    resolve(doc);
                }
            });
        });
    };
    ;
    //Put pouch db document
    PouchDbHelpers.prototype.Put = function (doc) {
        var that = this;
        return new Promise(function (resolve, reject) {
            that.db.put(doc).then(function (res) {
                resolve(res);
            }).catch(function (err) {
                reject(err);
            });
        });
    };
    ;
    //Delete document
    PouchDbHelpers.prototype.Remove = function (doc, compact) {
        var that = this;
        return new Promise(function (resolve, reject) {
            that.db.remove(doc).then(function (res) {
                if (compact) {
                    that.db.compact().then(function () {
                        resolve(res);
                    }).catch(function (err) {
                        console.error(err);
                        resolve(res);
                    });
                }
            }).catch(function (err) {
                console.error(err);
                reject(err);
            });
        });
    };
    ;
    return PouchDbHelpers;
}());
var Pdb = new PouchDbHelpers();
export default Pdb;
//# sourceMappingURL=Pdb.js.map